/* eslint-disable react-hooks/exhaustive-deps */
import BlankLayout from "layout/BlankLayout";
import ReviewInterestForm from "./components/ReviewInterestForm";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useEffect, useState } from "react";
import reviwImg from "images/placeholder-3.svg";

import { Activity } from "models/activity";
import { useQuery } from "react-query";
import { GET_ACTIVITY } from "query/queries";
import { useActivity } from "context/useActivity";
import { useAuth } from "context/useAuth";
import { find, map, extend } from "lodash";
import Loader from "components/loader/Loader";
import { useNavigate } from "react-router";

const ReviewInterest = () => {
  const [isFormSubmitted, setFormIsSubmitted] = useState<boolean>(false);
  const [hasError, setHasError] = useState<boolean>(false);
  const [activities, setActivities] = useState<Activity[]>([]);
  const { activityCtx, setActivityCtx } = useActivity();
  const { user } = useAuth();

  console.log("the activities", activityCtx);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const navigate = useNavigate();

  const { isLoading, refetch, isRefetching } = useQuery(
    ["activities"],
    () =>
      GET_ACTIVITY({
        keywords: [],
        user_id: user?.user_id,
        filters: {
          min_age: 1,
          max_age: 12,
          min_cost: 0,
          max_cost: 10000,
          min_prep_time: 0,
          max_prep_time: 5,
          min_learn_time: 0,
          max_learn_time: 10000,
        },
        mode: "search filters",
      }),
    {
      onSuccess: (data) => {
        setActivities(data.output_data);
        console.log("the data", data.keywords);
        setActivityCtx(
          extend(activityCtx, {
            interests: data.keywords,
          })
        );
      },
    }
  );

  const reviewInterestFormik = useFormik({
    initialValues: {
      activity: "",
      comment: "",
      filters: {
        min_age: 1,
        max_age: 12,
        min_cost: 0,
        max_cost: 10000,
        min_prep_time: 0,
        max_prep_time: 5,
        min_learn_time: 0,
        max_learn_time: 10000,
      },
      mode: "search filters",
    },
    validationSchema: Yup.object({
      activity: Yup.string().required("Activity is required"),
    }),
    onSubmit: (values) => {
      setActivityCtx({
        ...activityCtx,
        user_id: user.user_id,
        activity_id: values.activity,
        cycle_number: parseInt(activityCtx?.cycle_number) + 1,
        recommended_activities: map(activities, (act: any) => {
          return act.Activity_ID;
        }),
        selectedActivity: find(activities, (act: any) => {
          if (act.Activity_ID === values.activity) {
            return act;
          }
        }),
        mode: "put user feedback",
      });
      navigate("/give-feedback");
      setFormIsSubmitted(true);
      setHasError(false);
    },
  });

  useEffect(() => {
    if (activityCtx?.cycle_number !== 1) {
      refetch();
    }
  }, [activityCtx, activityCtx?.cycle_number]);

  return (
    <BlankLayout>
      <div className="section">
        <div className="container">
          <div className="intro-wrap">
            <div className="text-block heading-jumbo">
              Our database of STEM activities has over 1000 different
              explorations across many different topics and subject areas. The
              recommendations below represent the first set of three activities
              that closely match your interests and might get you excited to
              learn more. <br />
              <br />
              Please review each one and then select the one that most interests
              you. Note that you must submit your selections before you continue
              the study. On the next screen, you will be asked some questions
              about your selection. <br />
              <br />
              Once you have reviewed 3 sets of recommendation for a total of 9
              activities, the study will be complete.{" "}
            </div>
          </div>
        </div>
      </div>
      {isLoading || isRefetching ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "30vh",
            width: "100%",
          }}
        >
          <Loader />
        </div>
      ) : (
        <>
          <div className="section-3 wf-section">
            <div className="container-6 w-container">
              <h4 className="heading-3">
                Recommendation Set #{activityCtx?.cycle_number || 1}
              </h4>
              <div className="w-layout-grid grid-3">
                {(activities || []).slice(0, 3).map((activity: Activity) => (
                  <div
                    id="w-node-_47594a64-f80d-1765-d6b8-7fd7ed3fd5a4-34c243a2"
                    key={activity.Activity_Name}
                  >
                    <img
                      src={activity.image_url || reviwImg}
                      loading="lazy"
                      id="w-node-e322954b-3006-b242-9119-ca2946d62610-34c243a2"
                      alt=""
                    />
                    <a
                      href={activity.Activity_URL}
                      target="_blank"
                      className="link"
                      rel="noreferrer"
                    >
                      {activity.Activity_Name}
                    </a>
                    <div
                      id="w-node-_2ac58f0c-0728-6aa9-fbd3-7e3218b1e729-34c243a2"
                      className="text-block-3"
                    >
                      {activity.Activity_Desc}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="section-4 wf-section">
            <div className="container-5 w-container">
              <ReviewInterestForm
                reviewInterestFormik={reviewInterestFormik}
                isFormSubmitted={isFormSubmitted}
                hasError={hasError}
                activities={activities}
              />
            </div>
          </div>
          <div className="section-2 wf-section">
            {!isFormSubmitted && !hasError && (
              <>
                <div className="w-container">
                  <div className="text-block-2">
                    Please submit your responses before continuing the study.{" "}
                  </div>
                </div>
                <div className="container-3 w-container">
                  <button
                    type="button"
                    className="button-2 w-button"
                    onClick={() => reviewInterestFormik.handleSubmit()}
                  >
                    SUBMIT YOUR RESPONSES
                  </button>
                </div>
              </>
            )}
            {isFormSubmitted && !hasError && (
              <div className="container-4 w-container">
                <button
                  type="button"
                  onClick={() => navigate("/give-feedback")}
                  className="submit-button w-button"
                  style={{
                    pointerEvents: Boolean(isFormSubmitted && !hasError)
                      ? "auto"
                      : "none",
                    cursor: Boolean(isFormSubmitted && !hasError)
                      ? "pointer"
                      : "not-allowed",
                  }}
                >
                  CONTINUE STUDY
                </button>
              </div>
            )}
          </div>
        </>
      )}
    </BlankLayout>
  );
};

export default ReviewInterest;
